import { render, staticRenderFns } from "./WeeklyDealsSection.vue?vue&type=template&id=4429ca8e&"
import script from "./WeeklyDealsSection.vue?vue&type=script&lang=js&"
export * from "./WeeklyDealsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports